import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Grid, TextField } from "@mui/material";
import "./ConfirmDialog.css";

export default function ConfirmDialog({
  open,
  title,
  description,
  agreeText = "Agree",
  disagreeText = "Disagree",
  onClose,
  onAgree,
  absentPatient,
  noteText,
  setNoteText,
}) {
  const handleDisagree = () => {
    onClose?.();
  };

  const handleAgree = () => {
    onAgree?.();
    onClose?.();
  };

  const handleChange = (event) => {
    setNoteText(event.target.value);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xs"
    >
      <DialogTitle className="slot_dialog_title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className="slot_dialogtext"
        >
          {description}
        </DialogContentText>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {absentPatient && (
            <TextField
              fullWidth
              id="standard-basic"
              label="Enter the reson for absence"
              variant="standard"
              name="notes"
              value={noteText}
              className="custom-textfield"
              onChange={handleChange}
            />
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDisagree}>{disagreeText}</Button>
        <Button onClick={handleAgree} autoFocus>
          {agreeText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
